import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../Components/PageTitle'
import { ConfigContext } from '../../Context/ConfigContext'
import { GlobalLimitChanger, SubmitBtn } from '../../Components/InputElements'
import { ContentLoader, NoRecords, TableRows } from '../../Components/Shimmer'
import axios from 'axios'
import Swal from 'sweetalert2'

const Categories = () => {
    const { primaryColor, apiHeaderJson, apiURL, apiHeaderFile } = useContext(ConfigContext)
    const headersJson = apiHeaderJson;
    const headersFile = apiHeaderFile;
    const [isInfoLoading, setIsInfoLoading] = useState(false);

    const [categoryTitle, setCategoryTitle] = useState('')
    const [data, setData] = useState([])
    const [categoryId, setCategoryId] = useState('')
    const [next, setNext] = useState(false)
    const [prev, setPrev] = useState(false)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [loading, setLoading] = useState(true)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [keyword, setKeyword] = useState('')
    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const errors = {}
        if (!categoryTitle.trim()) {
            errors.categoryTitle = "Category title is required"
        }
        setErrors(errors)
        return Object.keys(errors).length === 0
    }

    const resetForm = () => {
        setCategoryTitle("")
        setErrors({})
        setCategoryId('')
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validateForm()) return

        setSubmitLoading(true)
        try {
            const formData = new FormData()
            formData.append('category_title', categoryTitle)

            if (categoryId) {
                formData.append('category_id', categoryId)
            }

            const response = await axios.post(`${apiURL}Masters/CreateCategory`, formData, { headers: headersFile })
            const { message, success } = response.data

            if (success) {
                resetForm()
                getData()
                Swal.fire('Success!', message, 'success')
            }
        } catch (error) {
            console.log("error", error)
            Swal.fire('Error!', 'Something went wrong', 'error')
        } finally {
            setSubmitLoading(false)
        }
    }

    const getData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${apiURL}Masters/GetCategories`, {
                headers: headersJson,
                params: {
                    keyword,
                    page,
                    limit
                }
            })
            const { success, data, page: currentPage, next, prev, total_pages, total_records } = response.data

            if (success) {
                setData(data)
                setPage(currentPage)
                setNext(next)
                setPrev(prev)
                setTotalPages(total_pages)
                setTotalRecords(total_records)
            }
        } catch (error) {
            console.log("error", error)
        } finally {
            setLoading(false)
        }
    }

    const getInfo = async (category_id) => {
        try {
            setIsInfoLoading(true);
            const response = await axios.get(`${apiURL}Masters/GetCategoryInfo`, {
                headers: headersJson,
                params: { category_id: category_id }
            })
            const { success, data } = response.data

            if (success && data[0]) {
                const category = data[0]
                setCategoryTitle(category.category_title)
                setCategoryId(category.category_id)
                setErrors({})
            }
        } catch (error) {
            console.log("error", error)
        } finally {
            setIsInfoLoading(false);
        }
    }

    const handleDelete = async (category_id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        })
        if (result.isConfirmed) {
            setLoading(true)
            try {
                const body = { category_id: category_id }
                const response = await axios.post(`${apiURL}Masters/DeleteCategory`, body, { headers: headersJson })
                const { message, success } = response.data

                Swal.fire('Deleted!', message, success ? 'success' : 'error')

                if (success) {
                    getData()
                }
            } catch (error) {
                console.error(error)
                Swal.fire('Error!', 'Something went wrong', 'error')
            } finally {
                setLoading(false)
            }
        }
    }

    const handlePrev = () => {
        if (prev) {
            setPage(prev => prev - 1)
        }
    }

    const handleNext = () => {
        if (next) {
            setPage(prev => prev + 1)
        }
    }

    const handleChange = (e) => {
        setPage(parseInt(e.target.value, 10))
    }

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getData()
        }, 500)

        return () => clearTimeout(delayDebounce)
    }, [keyword])

    useEffect(() => {
        getData()
    }, [limit, page])

    return (
        <>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <PageTitle title="Manage Categories" primary="Masters" />
                        {isInfoLoading && <ContentLoader />}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-header" style={{ backgroundColor: primaryColor }}>
                                        <h4 className="card-title mb-0 text-white">
                                            {categoryId ? 'Update Category' : 'New Category'}
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="categoryTitle">Category Title:</label>
                                                <input
                                                    type="text"
                                                    id="categoryTitle"
                                                    name="categoryTitle"
                                                    value={categoryTitle}
                                                    onChange={(e) => {
                                                        setCategoryTitle(e.target.value);
                                                        if (errors.categoryTitle) {
                                                            setErrors({ ...errors, categoryTitle: "" })
                                                        }
                                                    }}
                                                    className={`form-control ${errors.categoryTitle ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Category Title"
                                                />
                                                {errors.categoryTitle && <div className="invalid-feedback">{errors.categoryTitle}</div>}
                                            </div>

                                            <div className="col-md-12 mb-3">
                                                <div className='col-md-12 d-flex align-items-end justify-content-end gap-3 mt-3'>
                                                    {categoryId ? (
                                                        <>
                                                            <button
                                                                type="button"
                                                                className="btn btn-light btn-label right me-auto"
                                                                onClick={resetForm}
                                                            >
                                                                Reset
                                                                <i className="ri-arrow-right-line label-icon align-middle fs-16" />
                                                            </button>
                                                            <SubmitBtn
                                                                icon="ri-save-line"
                                                                text="Update"
                                                                onClick={handleSubmit}
                                                                type="primary"
                                                            />
                                                        </>
                                                    ) : (
                                                        <SubmitBtn
                                                            disabled={submitLoading}
                                                            text={submitLoading ? 'Saving..' : 'Save'}
                                                            type="primary"
                                                            onClick={handleSubmit}
                                                            icon="ri-save-line"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-header" style={{ backgroundColor: primaryColor }}>
                                        <div className="row d-flex align-items-center">
                                            <div className="col-md-7">
                                                <h4 className="card-title mb-0 text-white">Categories List</h4>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control pe-4"
                                                        placeholder="Search categories..."
                                                        name='keyword'
                                                        value={keyword}
                                                        onChange={(e) => setKeyword(e.target.value)}
                                                    />
                                                    <span className="position-absolute end-0 top-50 translate-middle-y me-3">
                                                        <i className="ri-search-line"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive table-card">
                                            <table className="table table-bordered table-striped table-nowrap table-hover mb-0">
                                                {loading ? (
                                                    <TableRows rows="10" colspan="3" />
                                                ) : (
                                                    <>
                                                        <thead className="table-light text-center">
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Category Title</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data.length > 0 ? (
                                                                data.map((row, index) => (
                                                                    <tr key={row.category_id} className="text-center">
                                                                        <td>{row.category_id}</td>
                                                                        <td>{row.category_title}</td>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-sm btn-soft-primary me-2"
                                                                                onClick={() => getInfo(row.category_id)}
                                                                            >
                                                                                <i className='ri-pencil-line'></i>
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-soft-danger"
                                                                                onClick={() => handleDelete(row.category_id)}
                                                                            >
                                                                                <i className='ri-delete-bin-line'></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3}>
                                                                        <NoRecords />
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                        <tfoot className='table-light'>
                                                            <tr>
                                                                <th colSpan={3}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <button disabled={!prev && !loading} type="button" onClick={handlePrev} className={`btn btn-warning btn-label waves-effect waves-light`}>
                                                                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous
                                                                        </button>
                                                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <small>Total Records: {totalRecords} | Total Pages: {totalPages} | Current Page: {page}</small>
                                                                        </div>
                                                                        <div className='col-md-2'>
                                                                            <select className="form-select" value={page} onChange={handleChange}>
                                                                                {Array.from({ length: totalPages }, (_, i) => (
                                                                                    <option key={i + 1} value={i + 1}>
                                                                                        {i + 1}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-2'>
                                                                            <GlobalLimitChanger
                                                                                placeholder="Set limit:"
                                                                                name="globalLimit"
                                                                                value={limit}
                                                                                onChange={setLimit}
                                                                                showAllValue={totalRecords}
                                                                            />
                                                                        </div>
                                                                        <button disabled={!next && !loading} type="button" onClick={handleNext} className={`btn btn-primary btn-label waves-effect right waves-light`}>
                                                                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next
                                                                        </button>
                                                                    </div>
                                                                </th>
                                                            </tr>
                                                        </tfoot>
                                                    </>
                                                )}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Categories;